import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Environment, environmentToken } from '@environment';
import { Observable } from 'rxjs';
import { FeatureWithVersionDTO } from '@app/shared/models/feature-firmware-version-dto.interface';

@Injectable({
  providedIn: 'root'
})
export class FeatureResource {
  private readonly apiUrl: string;
  constructor(private http: HttpClient, @Inject(environmentToken) environment: Environment) {
    this.apiUrl = environment.apiUrl + environment.apiPath + '/feature';
  }

  getFeatureForBuilding(
    feature: string,
    buildingId: number,
    nodeType?: string,
    picVersion?: number,
    nordicVersion?: number
  ): Observable<boolean> {
    return this.http.get<boolean>(`${this.apiUrl}/building/${buildingId}`, {
      params: this.buildParams(feature, nodeType, picVersion, nordicVersion)
    });
  }

  getFeature(feature: string, nodeType?: string, picVersion?: number, nordicVersion?: number): Observable<boolean> {
    return this.http.get<boolean>(this.apiUrl, {
      params: this.buildParams(feature, nodeType, picVersion, nordicVersion)
    });
  }

  getAllFeaturesForBuilding(buildingId: number): Observable<string[]> {
    return this.http.get<string[]>(`${this.apiUrl}/building/${buildingId}/all`);
  }

  getVersionBoundFeatures(): Observable<FeatureWithVersionDTO[]> {
    return this.http.get<FeatureWithVersionDTO[]>(`${this.apiUrl}/version`);
  }

  getVersionBoundFeaturesForBuilding(buildingId: number): Observable<FeatureWithVersionDTO[]> {
    return this.http.get<FeatureWithVersionDTO[]>(`${this.apiUrl}/building/${buildingId}/version`);
  }

  private buildParams(feature: string, nodeType?: string, picVersion?: number, nordicVersion?: number): HttpParams {
    let params = new HttpParams().set('feature', feature);
    if (nodeType != null) {
      params = params.set('nodeType', nodeType);
    }
    if (picVersion != null) {
      params = params.set('picVersion', picVersion.toString());
    }
    if (nordicVersion != null) {
      params = params.set('nordicVersion', nordicVersion.toString());
    }
    return params;
  }
}
